module.exports = __webpack_public_path__ + "fbe14e2fb0092a0745c8d56ab72c863f.png";